export default "__VITE_ASSET__DODKWTEb__"